export default "__VITE_ASSET__5654f3a3__"